import * as React from 'react';
import { CaseReportSectionTitle } from 'src/components/atomsLegacy/CaseReportSectionTitle';
import { BodyText } from 'src/components/atomsLegacy/typography';
import styled from 'styled-components';

export interface CaseReportEventDescriptionProps {
  title: string;
  content: string;
  ['data-testid']?: string;
}

export const CaseReportEventDescription: React.FC<
  CaseReportEventDescriptionProps
> = ({ title, content, ...props }) => {
  return (
    <CaseReportEventDescriptionContainer data-testid={props['data-testid']}>
      <CaseReportSectionTitle>{title}</CaseReportSectionTitle>
      <BodyText
        weight="regular"
        size="small"
        margin="6px 0 0 0"
        overflowWrapBreak
      >
        {content}
      </BodyText>
    </CaseReportEventDescriptionContainer>
  );
};

const CaseReportEventDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
